// extracted by mini-css-extract-plugin
export var buttonContainer = "_9t-1";
export var fontSizeSelect = "_9t-3";
export var formatSelect = "_9t-2";
export var formats = "_9t-4";
export var hidden = "_9t-5";
export var icon = "_9t-6";
export var select = "_9t-0";